/**
Project: Voice Panel (c)
Title: NoAccountNumber
Description: Component for displaying the No Regions Number page
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/

import React, { Component } from "react";
import {
    Text,
    Segment,
    Image
} from "@fluentui/react-northstar";
import { Grid, Row, Col } from "react-flexbox-grid";
import IntlUtil from "../../core/helpers/intl-util";
import { AppPageTitle } from "../../core/components/app-page-title";
import SippioVoicePanelLogo from "../../../assets/images/SIPPIO-VoicePanel-Logo.png";
import VoiceCallingImage from "../../../assets/images/illustrations/voice_calling.png";
import { AppConstants } from "../settings/app-constants";
import TokenUtil from "../helpers/token-util";

class NoRegions extends Component {
    _intl_ns_common = "common";
    _intl_ns_vpa_home = "vpa_home";


    render() {
        const accountDetail = TokenUtil.getIdentitySippioAccessTokenData();
        return (
            <>
                <AppPageTitle pageTitle={IntlUtil.getText(this._intl_ns_common, "title.noRegions")} />
                <div id="vpa-no-region-details">
                    <header className="vpa-no-region-details-header">
                        <Image
                            src={SippioVoicePanelLogo}
                            alt={IntlUtil.getText(
                                this._intl_ns_common,
                                "content.voicePanelBySippio"
                            )}
                            title={IntlUtil.getText(
                                this._intl_ns_common,
                                "content.voicePanelBySippio"
                            )}
                            className="vpa-image"
                        />
                    </header>
                    <div className="vpa-no-region-details-content">
                        <Grid fluid className="p-l-0 p-r-0">
                            <Row>
                                <Col xs={12} sm={12} md={8} lg={9} className="m-b-20">
                                    <Row>
                                        <Col xs={12} className="m-b-10">
                                            <Text className="vpa-title-text">
                                                {IntlUtil.getText(this._intl_ns_vpa_home, "content.welcome")}
                                            </Text>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} className="m-b-0">
                                            <Text as="p" className="vpa-text m-t-0 m-b-10">
                                                {IntlUtil.getText(
                                                    this._intl_ns_vpa_home,
                                                    "content.sippioCaption"
                                                )}
                                            </Text>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} className="m-b-10">
                                            <Text as="p" className="vpa-text m-t-0 m-b-10">
                                                {IntlUtil.getText(
                                                    this._intl_ns_vpa_home,
                                                    "content.sippioIntroduction"
                                                )}
                                            </Text>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} sm={8} md={6} lg={4} xl={5} >
                                            <Segment className="vpa-segment">
                                                <Text as="p" className="vpa-text m-t-5 m-b-5">
                                                    {IntlUtil.getText(
                                                        this._intl_ns_common,
                                                        "content.noRegionsNotconfigured"
                                                    )}
                                                </Text>
                                                <Text as="p" className="vpa-text m-t-5 m-b-5">
                                                    {IntlUtil.getText(
                                                        this._intl_ns_common,
                                                        "content.pleaseContact"
                                                    )} <a
                                                        href={`mailto:${AppConstants.SIPPIO_SUPPORT_EMAIL
                                                            }?subject=${IntlUtil.getSubstituteText(
                                                                this._intl_ns_common,
                                                                "content.emailSubject",
                                                                [
                                                                    {
                                                                        key: "<subscriberAccountNumber>",
                                                                        value: accountDetail.accountNumber ? accountDetail.accountNumber : null,
                                                                    },
                                                                ]
                                                            )}`}
                                                        className="vpa-page-link"
                                                    >
                                                        {IntlUtil.getText(
                                                            this._intl_ns_common,
                                                            "content.support"
                                                        )}
                                                    </a>
                                                </Text>
                                            </Segment>
                                        </Col >
                                    </Row>
                                </Col>
                                <Col xs={12} sm={12} md={4} lg={3} className="m-b-10">
                                    <Image src={VoiceCallingImage} alt="" className="vpa-page-image" />
                                </Col>
                            </Row>
                        </Grid>
                    </div>
                </div>
            </>
        )
    }

}

export default NoRegions